import { API_EMC } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function createCertType(data) {
  return {
    types: [
      ACTION_TYPES.CERTTYPE_CREATED_REQUESTED,
      ACTION_TYPES.CERTTYPE_CREATED_SUCCEED,
      ACTION_TYPES.CERTTYPE_CREATED_FAILED,
    ],
    promise: client => client.post('/types/', data),
    options: {
      clientName: API_EMC,
    },
  };
}

export function getListCertType() {
  return {
    types: [
      ACTION_TYPES.CERTTYPE_GOT_REQUESTED,
      ACTION_TYPES.CERTTYPE_GOT_SUCCEED,
      ACTION_TYPES.CERTTYPE_GOT_FAILED,
    ],
    promise: client =>
      client.get('/types/', {
        params: {
          pageSize: 1000,
        },
      }),
    options: {
      clientName: API_EMC,
    },
  };
}

export function updateCertType(typeId, data) {
  return {
    types: [
      ACTION_TYPES.CERTTYPE_UPDATED_REQUESTED,
      ACTION_TYPES.CERTTYPE_UPDATED_SUCCEED,
      ACTION_TYPES.CERTTYPE_UPDATED_FAILED,
    ],
    promise: client => client.patch(`/types/${typeId}/`, data),
    typeId,
    options: {
      clientName: API_EMC,
    },
  };
}

export function deleteCertType(typeId) {
  return {
    types: [
      ACTION_TYPES.CERTTYPE_DELETED_REQUESTED,
      ACTION_TYPES.CERTTYPE_DELETED_SUCCEED,
      ACTION_TYPES.CERTTYPE_DELETED_FAILED,
    ],
    promise: client => client.delete(`/types/${typeId}/`),
    typeId,
    options: {
      clientName: API_EMC,
    },
  };
}

export function getMinimumFee(doctorId) {
  return {
    types: [
      ACTION_TYPES.MINIMUM_FEE_GOT_REQUESTED,
      ACTION_TYPES.MINIMUM_FEE_GOT_SUCCEED,
      ACTION_TYPES.MINIMUM_FEE_GOT_FAILED,
    ],
    promise: client => client.get(`/doctors/${doctorId}/minimum-fee/`),
    options: {
      clientName: API_EMC,
    },
  };
}

export function getCertFee(doctorId) {
  return {
    types: [
      ACTION_TYPES.CERT_FEE_GOT_REQUESTED,
      ACTION_TYPES.CERT_FEE_GOT_SUCCEED,
      ACTION_TYPES.CERT_FEE_GOT_FAILED,
    ],
    promise: client => client.get(`/doctors/${doctorId}/cert-fee/`),
    options: {
      clientName: API_EMC,
    },
  };
}

export function updateCertFee(doctorId, price) {
  return {
    types: [
      ACTION_TYPES.CERT_FEE_UPDATED_REQUESTED,
      ACTION_TYPES.CERT_FEE_UPDATED_SUCCEED,
      ACTION_TYPES.CERT_FEE_UPDATED_FAILED,
    ],
    promise: client => client.patch(`/doctors/${doctorId}/cert-fee/`, price),
    options: {
      clientName: API_EMC,
    },
  };
}
